var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31827 1.93739C1.44048 1.67086 1.7068 1.5 2.00001 1.5H22C22.2932 1.5 22.5595 1.67086 22.6818 1.93739C22.804 2.20391 22.7597 2.51721 22.5683 2.73939L15 11.5284V21.75C15 22.0266 14.8478 22.2807 14.6039 22.4113C14.36 22.5418 14.0641 22.5275 13.834 22.374L9.33397 19.374C9.12532 19.2349 9 19.0008 9 18.75V11.5284L1.43168 2.73939C1.24036 2.51721 1.19605 2.20391 1.31827 1.93739ZM3.63559 3L10.3183 10.7606C10.4355 10.8967 10.5 11.0704 10.5 11.25V18.3486L13.5 20.3486V11.25C13.5 11.0704 13.5645 10.8967 13.6817 10.7606L20.3644 3H3.63559Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.e20025c34d93bf1b51b87358afaf071a.svg";